namespace $.$$ {

	export class $shm_projects_codex_prompt_edit extends $.$shm_projects_codex_prompt_edit {

		@ $mol_action
		scroll_event( event?: Event ) {
			if( !event ) return null
			this.scroll_top(( this.dom_node() as HTMLTextAreaElement ).scrollTop )
			return event
		}

	}

	export class $shm_projects_codex_prompt extends $.$shm_projects_codex_prompt {

		override enter_key( event?: KeyboardEvent ) {
			if( !event || event.isComposing ) return event ?? null
			event.preventDefault()
			this.enter_submit( event )
			return event
		}

		scroll_transform() {
			this.value()
			this.scroll_top()
			const top = ( this.Edit().dom_node() as HTMLTextAreaElement ).scrollTop
			return `translateY( ${ -top }px )`
		}

	}

}
